import gql from 'graphql-tag'
import {
  eventResultFragment,
  cityResultFragment,
  artistResultFragment,
  locationResultFragment,
} from '~/graphql/fragments'

export const GET_SEARCH_RESULTS = gql`
  query getSearchResults(
    $query: String!
    $first: Int!
    $after: String
    $type: SearchType
  ) {
    search(query: $query, first: $first, after: $after, type: $type) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          ... on EventResult {
            ...eventResult
          }
          ... on CityResult {
            ...cityResult
          }
          ... on LocationResult {
            ...locationResult
          }
          ... on ArtistResult {
            ...artistResult
          }
        }
      }
    }
  }
  ${eventResultFragment}
  ${cityResultFragment}
  ${locationResultFragment}
  ${artistResultFragment}
`
